<div class="item__info border-radius">
  @if (isAuthenticated$ | async) {
    <app-is-favorite
      linkClass="item__fav"
      [imageId]="(imageId$ | async)!"
      [isFavorite]="(isFavorite$ | async)!"
    />
  }
  <div class="item__title">
    {{ imageName$ | async }}
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="item__price">
      @for (imageDetail of imageDetails$ | async; track $index) {
        <label class="radio" (click)="onClick($event)">
          <div class="item__size">
            @if (imageDetail.url) {
              <div class="space"></div>
            } @else {
              <input
                name="detail_id"
                formControlName="detail_id"
                type="radio"
                [value]="imageDetail.id"
              /><span></span>
            }
            <div class="content-type">{{ imageDetail.type }}</div>
            <p>{{ imageDetail.width }}x{{ imageDetail.height }}</p>
          </div>
          <strong>
            @if (imageDetail.url) {
              <a class="download-link" [href]="imageDetail.url" download>
                <img
                  class="download-link__icon"
                  src="assets/icon-download.svg"
                  width="110"
                  height="104"
                  alt="Download image"
                />
              </a>
            } @else {
              {{ imageDetail.price! | price }}
            }
          </strong>
        </label>
      }
    </div>
    <button type="submit" class="button button_dark button_standard w100">
      {{
        (containsAsync(imageDetailsIds$, detailIdFC.value) | async)
          ? 'Remove from cart'
          : 'Add to cart'
      }}
    </button>
  </form>
  @if (false) {
    <div class="item__price-options">
      <div>Single image download price</div>
      <app-toggle-switch />
      <div>Price with subscription</div>
    </div>
    <a routerLink="/plans" class="item__plans">Show subscription plans</a>
  }
</div>
